import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Hotjar from '@hotjar/browser';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

const localhost = window.location.hostname === 'localhost';

export const useHotjarUser = () => {
	const account = useSelector((state) => state.msalAccount?.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	useEffect(() => {
		if (!email || !userDetails || localhost) return;

		Hotjar.identify(email, {
			email,
			name: account?.name,
			brokerGroupId: userDetails.brokerGroupId,
			brokerGroup: userDetails.broker?.name,
		});
	}, [email, userDetails, account]);
};
